const colors = {
    primary: '#3A7F59',
    primaryHover: '#3A7F15',
    secondary: '#3A7F59',
    white: '#ffffff'
};

export default colors;
